import { createDp } from "./_dp.js";
import { createCombobox } from "./_combobox.js";
import { createListBox } from "./_listbox.js";
import createTimebox from "./_timebox.js";
import createParkingWidgetV1 from "./_parking-widget-v1.js";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

const mq = window.matchMedia("(min-width: 576px)");
const toTwo = num => ("0" + num).slice(-2);

async function init($form) {
  $form.addEventListener("submit", e => {
    e.preventDefault();

    let redirectUrl = "";

    let data = new window.FormData($form),
      dataParsed = "";
    for (let pair of data.entries()) {
      if (pair[0] == "jsRedirectUrl") {
        redirectUrl = pair[1];
        continue;
      }
      dataParsed += `${encodeURI(pair[0])}=${encodeURI(pair[1])}&`;
    }

    dataParsed = dataParsed.substring(0, dataParsed.length - 1);

    $form.querySelector("[type=submit] .js-spinner").hidden = false

    return (window.location.href = `${redirectUrl}?${dataParsed}`);
  });

  const $fallback = document.getElementById(
    $form.getAttribute("data-fallback")
  );
  const $toggleFallbacks = [
    ...$form.querySelectorAll(".js-parking-widget-v2-toggle-fallback"),
    ...$fallback.querySelectorAll(".js-parking-widget-v2-toggle-fallback")
  ];

  $toggleFallbacks.forEach($toggleFallback => {
    $toggleFallback.addEventListener("click", () => {
      toggleFallback();
    });
  });

  function toggleFallback() {
    if ($fallback) {
      $fallback.hidden = !$fallback.hidden;
      $form.hidden = !$form.hidden;
    }
  }

  let $departingDate = $form.querySelector(
    ".js-parking-widget-v2-departing-date"
  );
  let $returningDate = $form.querySelector(
    ".js-parking-widget-v2-returning-date"
  );
  let returningDatePicker;

  let currentStep = 1;
  let departingDate;
  let returningDate;
  let departingFlights;
  let returningFlights;
  let applicableReturnDates;
  let code;
  let reinit = false;
  let adults;
  let children;

  const sameDay = (d1, d2) => {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };

  const sortBy = (a, b) => {
    // Use toUpperCase() to ignore character casing
    const bandA = a.destination.toUpperCase();
    const bandB = b.destination.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  if ($returningDate) {
    returningDatePicker = await createDp($returningDate, {
      minDate: new Date(),
      container: $returningDate.parentNode,
      numberOfMonths: mq.matches ? 2 : 1,
      disableDayFn(day) {
        return applicableReturnDates.findIndex(ard => ard.getTime() === day.getTime()) < 0
      },
      onSelect() {
        let theDate = new Date(this._d);
        let date = this.getDate();

        window
          .fetch(
            `https://lba-flights.production.parallax.dev/inboundFlightsByOrigin?origin_iata=${code}`
          )
          .then(response => {
            return response.json();
          })
          .then(json => {
            let inboundFlightsOnDay = json.filter(flight =>
              sameDay(
                new Date(flight.scheduled_arrival.replace(" ", "T")),
                theDate
              )
            );

            //inboundFlightsOnDay.sort(sortBy)

            if (inboundFlightsOnDay.length) {
              this.setEndRange(date);
              this.el.classList.add("has-endrange");

              returningDate = date;
              let $trigger = document.getElementById(
                $returningDate.getAttribute("data-trigger")
              );

              $trigger.textContent = `Return Date: ${date.getDate()}${nth(
                date.getDate()
              )} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;

              showStep(5, initStep5);
            } else {
              alert("No flights on selected date, please try again.");
            }
          });
      }
    });
    returningDatePicker.el.addEventListener("mouseover", e => {
      if (!e.target) return;
      let $day = e.target.closest(".pika-day");
      if (!$day) return;

      let date = new Date(
        parseInt($day.getAttribute("data-pika-year"), 10),
        parseInt($day.getAttribute("data-pika-month"), 10),
        parseInt($day.getAttribute("data-pika-day"), 10)
      );
      if (
        !returningDatePicker._o.endRange ||
        returningDatePicker._o.endRange.getTime() !== date.getTime()
      ) {
        if (returningDatePicker._o.startRange.getTime() <= date.getTime()) {
          returningDatePicker.setEndRange(date);
        } else {
          returningDatePicker.setEndRange(null);
        }
        returningDatePicker.draw();
      }
    });
  }

  let departingDatePicker = await createDp($departingDate, {
    minDate: new Date(),
    container: $departingDate.parentNode,
    // bound: false,
    numberOfMonths: mq.matches ? 2 : 1,
    onSelect() {
      let date = this.getDate();

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      fetchOutboundFlights({ day, month, year }).then(flights => {
        if (flights.length) {
          departingDate = date;
          let $trigger = document.getElementById(
            $departingDate.getAttribute("data-trigger")
          );

          $trigger.textContent = `Departure Date: ${date.getDate()}${nth(
            date.getDate()
          )} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;

          if (returningDatePicker) {
            returningDatePicker.setMinDate(date);
            returningDatePicker.setStartRange(date);
            returningDatePicker.el.classList.add("has-startrange");
          }

          let $manual = $form.querySelector(".js-parking-widget-v2-manual");
          // if ($manual) {
          //   $manual.parentNode.removeChild($manual);
          // }

          if (currentStep === 1) {
            showStep(2, initStep2);
          } else {
            revertToStep(2, initStep2);
          }
        } else {
          alert("No flights on selected date, please try again.");
        }
      });
    }
  });

  const fetchOutboundFlights = ({ day, month, year }) =>
    window
      .fetch(
        `https://lba-flights.production.parallax.dev/outboundFlightsByDay?day=${year}-${month}-${day}`
      )
      .then(response => {
        return response.json();
      })
      .then(json => {
        departingFlights = json;

        return json
          .map(
            ({ destination_name, destination_country, destination_iata }) => ({
              destination: destination_name || "",
              country: destination_country || "",
              code: destination_iata || ""
            })
          )
          .reduce((arr, flight) => {
            let exists = false;
            arr.forEach(existingFlight => {
              if (JSON.stringify(flight) === JSON.stringify(existingFlight)) {
                exists = true;
              }
            });

            if (!exists) arr.push(flight);
            return arr;
          }, [])
          .sort((a, b) => {
            // Use toUpperCase() to ignore character casing
            const bandA = a.destination.toUpperCase();
            const bandB = b.destination.toUpperCase();

            let comparison = 0;
            if (bandA > bandB) {
              comparison = 1;
            } else if (bandA < bandB) {
              comparison = -1;
            }
            return comparison;
          });
      });

  function initStep2() {
    currentStep = 2;

    createCombobox($form.querySelector(".js-combobox"), {
      async getOptions() {
        let day = departingDate.getDate();
        let month = departingDate.getMonth() + 1;
        let year = departingDate.getFullYear();

        return fetchOutboundFlights({ day, month, year });
      },
      onSelect() {
        code = $form.querySelector(".js-combobox").getAttribute("data-code");

        if (currentStep === 2) {
          showStep(3, initStep3);
        } else {
          revertToStep(3, _ => {
            initStep3()
            initStep4()
            initStep5()
            currentStep = 3
          });
        }
      },
      onReady() {
        $form.querySelector(".js-combobox").focus();
      },
      append: {
        country: "",
        destination: "My flight isn't listed",
        code: "",
        onSelect: () => {
          toggleFallback();
          return false;
        }
      }
    });
  }

  function initStep3() {
    currentStep = 3;
    const defaultLabel = 'Which flight are you departing on?'

    createListBox(
      $form.querySelector(".js-parking-widget-v2-departing-flight"),
      {
        reinit,
        defaultLabel,
        async getOptions() {
          return departingFlights
            .reduce((arr, flight) => {
              if (flight.destination_iata === code) {
                arr.push(flight);
              }
              return arr;
            }, [])
            .map(({ scheduled_departure, airline_name, flight_ident }) => {
              let dateTime = new Date(scheduled_departure.replace(" ", "T"));
              return {
                time: `${toTwo(dateTime.getHours())}:${toTwo(
                  dateTime.getMinutes()
                )}`,
                airline: airline_name,
                number: flight_ident
              };
            })
            .sort((a, b) => {
              if (a.time === b.time) return 0;
              return a.time > b.time;
            });
        },
        onClose({ getValue }) {
          if (!getValue()) return;
          showStep(4, initStep4);
        },
        onSelect() {
          if($form.querySelector(".js-parking-widget-v2-returning-flight")) {
            window
            .fetch(`https://lba-flights.production.parallax.dev/inboundFlightsByOrigin?origin_iata=${code}`)
            .then(response => response.json()).then(json => {
              const flights = json
                .filter(flight => flight.origin_iata === code)
                .map(({ scheduled_departure }) => scheduled_departure.split(' ')[0])
              applicableReturnDates = [...new Set(flights)]
              applicableReturnDates = applicableReturnDates.map(date => {
                date = date.split("-")
                return new Date(`${date[1]}/${date[2]}/${date[0]}`)
              })
            })
          }
        }
      }
    );
  }

  function initStep4() {
    currentStep = 4
    adults = 0
    children = 0
    const labels = {
      adults: "Adults (16+): 0",
      children: "Children (2-15): 0"
    }
    Object.entries(labels).forEach(([key, label]) => {
      $form.querySelector(`.js-parking-widget-v2-${key}`).textContent = label
      $form.querySelector(`#lounge-${key}-options`).removeAttribute("aria-activedescendant")
      $form.querySelector(`#lounge-${key}`).removeAttribute("value")
    })
    $form.classList.remove("-step-4", "-step-5", "-step-6", "-step-7")
    $form.querySelector(".js-parking-widget-v2-5").hidden = true
  }

  function initStep5() {
    currentStep = 4;
    const defaultLabel = 'Which flight are you returning on?'

    let $returningFlight = $form.querySelector(
      ".js-parking-widget-v2-returning-flight"
    );
    if ($returningFlight) {
      createListBox($returningFlight, {
        reinit,
        defaultLabel,
        async getOptions() {
          let day = returningDate.getDate();
          let month = returningDate.getMonth() + 1;
          let year = returningDate.getFullYear();

          return window
            .fetch(
              `https://lba-flights.production.parallax.dev/inboundFlightsByDay?day=${year}-${month}-${day}`
            )
            .then(response => {
              return response.json();
            })
            .then(json => {
              returningFlights = json;

              return json
                .filter(flight => flight.origin_iata === code)
                .map(({ scheduled_arrival, airline_name, flight_ident }) => {
                  let dateTime = new Date(scheduled_arrival.replace(" ", "T"));
                  return {
                    time: `${toTwo(dateTime.getHours())}:${toTwo(
                      dateTime.getMinutes()
                    )}`,
                    airline: airline_name,
                    number: flight_ident
                  };
                })
                .sort((a, b) => {
                  if (a.time === b.time) return 0;
                  return a.time > b.time;
                });
            });
        },
        onSelect() {
          showStep(6);
        }
      });
    }
  }

  function showStep(step, cb) {
    $form.querySelector(`.js-parking-widget-v2-${step}`).hidden = false;
    $form.classList.add(`-step-${step}`);

    if (cb) cb();
  }

  function revertToStep(step, cb) {
    reinit = true
    const fields = $form.querySelectorAll(`.js-parking-widget-v2-field`)
    fields.forEach((_, i) => {
      const current = i + 1
      const field = $form.querySelector(`.js-parking-widget-v2-${current}`)
      if(current <= step) {
        field.hidden = false
        $form.classList.add(`-step-${current}`)
      } else {
        field.hidden = true
        $form.classList.remove(`-step-${current}`)
      }
    })
    currentStep = step - 1;

    if (cb) cb();
  }

  /**
   * Lounge
   */
  // let $arrivalTime = $form.querySelector('.js-parking-widget-v2-arrival-time')
  // if ($arrivalTime) {
  //   createTimebox($arrivalTime, {
  //     onClose ({ getValue, disable, $list }) {
  //       if (getValue()) {
  //         let $container = $list.parentNode
  //         $container.className = $container.className.replace(
  //           /\bborder-[a-z-]+\b/,
  //           'border-transparent text-grey'
  //         )
  //         disable()
  //         showStep(5)
  //       }
  //     }
  //   })
  // }

  let $adults = $form.querySelector(".js-parking-widget-v2-adults");
  if ($adults) {
    createListBox($adults, {
      reinit,
      onSelect({ getValue }) {
        $form.classList.add("-step-6");

        adults = getValue();

        if (adults) {
          showStep(5);
        }
      }
    });
  }

  let $children = $form.querySelector(".js-parking-widget-v2-children");
  if ($children) {
    createListBox($children, {
      reinit,
      onSelect({ getValue }) {
        $form.classList.add("-step-7");

        children = getValue();

        if (adults) {
          showStep(5);
        }
      }
    });
  }
}

let $forms = document.querySelectorAll(".js-parking-widget-v2");
for (let i = 0; i < $forms.length; i++) {
  init($forms[i]);
}

let $loungeForm = document.getElementById('lounge-widget-fallback')
if ($loungeForm) createParkingWidgetV1($loungeForm)

// let $formsV1 = document.querySelectorAll(".js-parking-widget-v1");
// for (let i = 0; i < $formsV1.length; i++) {
//   // createParkingWidgetV1($formsV1[i]);
// }

window.LBA.initWidget = $root => {
  let $forms = $root.querySelectorAll("form");
  // init($forms[0]);
  createParkingWidgetV1($forms[0]);
};

window.LBA.initWidgetV1 = $root => {
  let $form = $root.querySelector("form");
  createParkingWidgetV1($form);
};

function nth(d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}



// WEBPACK FOOTER //
// ./src/js/_parking-widget.js